<app-signature-upload
  [currentAccountId]="currentAccountId"
  [isReadDataFromSassEnabled]="isReadDataFromSassEnabled"
  [mode]="'add'"
/>
